export const mobilePayment = {
  mobilePaymentBank: "银行",
  mobilePaymentPhone: "电话号码",
  mobilePaymentAction: "管理",
  mobilePaymentEdit: "编辑",
  mobilePaymentDelete: "删除",
  mobilePaymentDeleteConfirm: "是否确认删除手机支付账户?",
  mobilePaymentDeleteYes: "是",
  mobilePaymentDeleteNo: "否",

  mobilePaymentTitle: "手机支付",
  mobilePaymentAdd: "添加手机支付",
  mobilePaymentBtnAdd: "添加",
  mobilePaymentBtnBack: "返回",

  mobilePaymentEditTitle: "编辑手机支付账户",

  mobilePaymentModalBank: "银行",
  mobilePaymentModalPhone: "电话号码",
  mobilePaymentModalSelectBank: "选择银行",
  mobilePaymentModalSelectBankMessage: "请选择一个银行",
  mobilePaymentModalPhonePlaceholder: "电话号码",
  mobilePaymentModalPhonePlaceholderMessage: "请输入您的电话号码",
  mobilePaymentModalSubmitBtn: "确认",

  // New registration modal translations
  pagoMovilRegistrationTitle: "需要手机支付注册",
  pagoMovilRegistrationMessage: "要使用手机支付进行存款或取款，您需要注册您的身份证和电话号码。",
  pagoMovilRegistrationCedula: "身份证",
  pagoMovilRegistrationCedulaPlaceholder: "请输入您的身份证号码",
  pagoMovilRegistrationCedulaMessage: "请输入您的身份证号码",
  pagoMovilRegistrationCedulaValidation: "只允许输入数字",
  pagoMovilRegistrationCedulaMinLength: "身份证号码至少需要7位数字",
  pagoMovilRegistrationCedulaMaxLength: "身份证号码不能超过15位数字",
  pagoMovilRegistrationPhoneNumber: "电话号码",
  pagoMovilRegistrationPhoneNumberPlaceholder: "请输入您的电话号码",
  pagoMovilRegistrationPhoneNumberMessage: "请输入您的电话号码",
  pagoMovilRegistrationPhoneValidation: "请输入有效的电话号码",
  pagoMovilRegistrationPhoneMinLength: "电话号码至少需要10位数字",
  pagoMovilRegistrationSubmitBtn: "注册",
  pagoMovilRegistrationCancelBtn: "取消",
  pagoMovilRegistrationSuccessTitle: "数据注册成功",
  pagoMovilRegistrationSuccessMessage: "您的身份证和电话号码已成功注册。",
  pagoMovilRegistrationErrorTitle: "数据注册错误",
  pagoMovilRegistrationErrorMessage: "注册您的信息时出现错误。请重试。",

  // AddPagoMovil form translations
  addPagoMovilExplanationTitle: "需要个人信息注册",
  addPagoMovilExplanationMessage:
    "要添加手机支付账户，我们需要您注册个人信息（姓名、身份证和电话号码）。此信息是安全处理存款和取款所必需的。",
  registerAndAddPagoMovil: "注册并添加手机支付",

  // Basic field names
  name: "姓名",
  lastName: "姓氏",
  nationalID: "身份证",
  phoneNumber: "电话号码",
  nameRequired: "姓名是必需的",
  lastNameRequired: "姓氏是必需的",
  nationalIDRequired: "身份证是必需的",
  phoneNumberRequired: "电话号码是必需的",
  phoneNumberMinLength: "电话号码至少需要10位数字",
  phoneNumberMaxLength: "电话号码不能超过11位数字",

  // Confirmation overlay translations
  confirmSaveChanges: "您确定要保存更改吗？",
  accept: "确认",
  cancel: "取消",

  // Delete confirmation modal translations
  deleteConfirmationTitle: "删除手机支付账户",
  deleteConfirmationMessage: "您即将删除其中一个手机支付账户",
  deleteConfirmationBank: "银行",
  deleteConfirmationPhone: "电话号码",

  // Email verification translations
  registrationEmailVerificationTitle: "电子邮件验证",
  registrationEmailVerificationMessage: "验证链接已发送到您的电子邮件地址。请检查您的收件箱并点击链接以继续。",
};
